import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

// Interceptor global para añadir Authorization automáticamente
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers = config.headers || {};
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

const API = process.env.REACT_APP_API_URL || process.env.REACT_APP_BACKEND_URL;

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    checkAuth();
  }, []);

  const getAuthHeader = () => {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  const checkAuth = async () => {
    try {
      const { data } = await axios.get(`${API}/api/auth/me`, { headers: getAuthHeader() });
      setUser(data.user || data);
    } catch (err) {
      setUser(false);
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    try {
      // FastAPI espera username y password (no email)
      const { data } = await axios.post(`${API}/api/auth/login`, { username: email, password });
      if (data.token) localStorage.setItem('token', data.token);
      setUser(data.user);
      return data;
    } catch (err) {
      alert('Error de login: ' + (err.response?.data?.detail || err.message));
      throw err;
    }
  };

  const register = async (email, password, name) => {
    try {
      const { data } = await axios.post(`${API}/api/auth/register`, { email, password, name });
      if (data.token) localStorage.setItem('token', data.token);
      setUser(data.user);
      return data;
    } catch (err) {
      alert('Error de registro: ' + (err.response?.data?.detail || err.message));
      throw err;
    }
  };

  const logout = async () => {
    localStorage.removeItem('token');
    setUser(false);
  };

  const completeOnboarding = async (businessData) => {
    const { data } = await axios.post(`${API}/api/auth/onboarding`, businessData, { headers: getAuthHeader() });
    setUser(prev => ({ ...prev, onboarding_complete: true, business_name: data.business_name }));
    return data;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, completeOnboarding, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
}
